// extracted by mini-css-extract-plugin
export var box = "Boxes-module--box--fcf69";
export var decorativeNumber = "Boxes-module--decorativeNumber--0ddc1";
export var open = "Boxes-module--open--aa14f";
export var simple = "Boxes-module--simple--72d5a";
export var svgCircle = "Boxes-module--svgCircle--1e30b";